import React, { useEffect, useState } from "react";
import usePageTitle from '../../hooks/usePageTitle';
import DashboardShell from "../../components/Dashboard/DashboardShell";
import ChatList from "../../components/Dashboard/Chats/ChatList";
import MessageBox from "../../components/Dashboard/Chats/MessageBox";
import ChatProvider from "../../context/ChatProvider";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function ChatPage() {
  usePageTitle('Chat');
  const { t } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const [fetchAgain, setFetchAgain] = useState(false);
  const user = useSelector((state) => state.user);
  const { userId } = useParams();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const [selectedChat, setSelectedChat] = useState(false);

  useEffect(() => {
    if (userId) {
      navigate(`/dashboard/chat/${userId}`);
    }
  }, [userId, navigate]);

  const handleChatSelected = () => setSelectedChat(true);
  const handleGoBack = () => setSelectedChat(false);

  return (
    <ChatProvider>
      <DashboardShell role={user.role} pageTitle={t("Messages")}>
        <div className="tw-h-full tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-min-h-0">
          {/* Chat list panel */}
          <div className={`tw-rounded-xl tw-bg-[#280D41] tw-border tw-border-white/10 tw-overflow-hidden tw-flex tw-flex-col
            ${selectedChat ? "tw-hidden md:tw-flex" : "tw-flex"}`}
          >
            <div className="tw-p-4 tw-border-b tw-border-white/10">
              <div className="tw-relative">
                <input
                  type="text"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="tw-w-full tw-rounded-lg tw-border tw-border-white/20 tw-bg-[#190033] tw-py-2 tw-pl-9 tw-pr-4 tw-text-sm tw-text-white placeholder:tw-text-white/40 focus:tw-border-[#712CB0] focus:tw-outline-none"
                  placeholder={t("Search...")}
                />
                <FontAwesomeIcon
                  icon={faSearch}
                  className="tw-absolute tw-left-3 tw-top-2.5 tw-text-xs tw-text-white/40 tw-pointer-events-none"
                />
              </div>
            </div>
            <div className="tw-flex-1 tw-overflow-auto">
              <ChatList
                fetchAgain={fetchAgain}
                userId={userId || null}
                searchValue={searchValue}
                onChatItemClick={handleChatSelected}
              />
            </div>
          </div>

          {/* Message box panel */}
          <div className={`tw-col-span-2 tw-rounded-xl tw-bg-[#280D41] tw-border tw-border-white/10 tw-overflow-hidden
            ${selectedChat ? "tw-flex" : "tw-hidden md:tw-flex"}`}
          >
            <MessageBox
              fetchAgain={fetchAgain}
              setFetchAgain={setFetchAgain}
              onBackToChatList={handleGoBack}
            />
          </div>
        </div>
      </DashboardShell>
    </ChatProvider>
  );
}
